export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7327.543745f1.jpg";